import React, { useState, useEffect } from 'react';
import classnames from "classnames";
import {
	Collapse,
	Card,
	CardBody,
} from "reactstrap";

import Breadcrumbs from "components/Common/Breadcrumb";

const accordionData = [
	{
		title: "(CRM ARCHI) Вход и выход из системы. Знакомство с профилем",
		content: "Вход и выход из системы. Знакомство с профилем",
	},
	{
		title: "(CRM ARCHI) Добавление клиентов, услуг и абонементов",
		content: "Добавление клиентов, услуг и абонементов",
	},
	{
		title: "(CRM ARCHI) Запись на прием",
		content: "Запись на прием к специалисту",
	},
	{
		title: "(CRM ARCHI) Отметка времени работы в системе",
		content: "Отметка времени работы в системе",
	},
	{
		title: "(CRM ARCHI) Работа с абонементами",
		content: "Работа с абонементами",
	},
	{
		title: "(CRM ARCHI) Создание и обработка заявок",
		content: "Создание и обработка заявок",
	},
	{
		title: "Аффинити",
		content: "Аффинити (Affinity) - это понятие, которое широко используется в различных областях, включая науку, психологию, маркетинг и дизайн. В общем смысле, аффинити описывает привлекательность, схожесть или сочетаемость между разными элементами или субъектами.",
	},
	{
		title: "Бизнес",
		content: "Бизнес - это организация или предпринимательская деятельность, направленная на создание и продажу товаров или предоставление услуг с целью получения прибыли. Бизнес может быть организован в виде фирмы, компании, стартапа или индивидуального предпринимателя.Основная цель бизнеса заключается в создании ценности для клиентов и обеспечении удовлетворения их потребностей через предложение продуктов или услуг. Бизнес может включать в себя различные функции, такие как производство, маркетинг, продажи, финансы, управление ресурсами и другие. Бизнес охватывает широкий спектр деятельности, начиная с малых предприятий и семейных бизнесов до крупных корпораций и международных компаний. В зависимости от типа бизнеса, сектора экономики и масштабов операций, организации могут принимать различные формы, такие как частная собственность, публичные компании, кооперативы или некоммерческие организации.",
	},
	{
		title: "Время",
		content: "Время - это абстрактное понятие, которое используется для измерения протекания событий, изменения и последовательности во временной шкале. В широком смысле, время представляет собой непрерывное движение или прогресс, который можно измерять и описывать.",
	},
	{
		title: "Выживание",
		content: "Выживание - это процесс сохранения жизни и приспособления к неблагоприятным условиям или ситуациям. Оно относится к основным инстинктам и врожденным механизмам, которые помогают организму сохранить жизнь и преодолеть трудности.",
	},
	{
		title: "Гармония",
		content: "Гармония - это состояние равновесия, согласованности и единства между различными элементами, факторами или аспектами. В разных контекстах понятие гармонии может иметь различные значения, но общая идея заключается в создании баланса, согласованности и приятного восприятия.",
	},
	{
		title: "Генетическая сущность",
		content: "Выражение генетическая сущность обычно относится к основным генетическим характеристикам или свойствам, которые определяют особенности организма или видового наследия. Генетика изучает наследственность и передачу генетической информации от одного поколения к другому. Она исследует структуру, функцию и взаимодействие генов, которые содержат информацию о наследуемых чертах. Гены являются носителями наследственной информации и определяют особенности организма, такие как внешний вид, физические характеристики, поведение и предрасположенность к определенным заболеваниям.",
	},
	{
		title: "Динамика",
		content: "Динамика - это понятие, которое описывает изменение, движение и развитие объектов, процессов или систем во времени. Оно относится к изучению и пониманию того, как объекты или системы изменяются, взаимодействуют друг с другом и развиваются в определенном контексте.",
	},
	{
		title: "Данные",
		content: "Данные - это фактические сведения, факты или информация, которая представлена в форме, доступной для обработки и использования. Данные могут быть представлены в различных форматах, включая текст, числа, изображения, звуки и другие медиа-файлы.",
	},
	{
		title: "Здравый смысл",
		content: "Здравый смысл - это понятие, которое описывает способность рационально мыслить, делать выводы и принимать решения на основе общепринятых норм и логики. Он является неким врожденным или приобретенным чувством оценки ситуаций, обстоятельств и действий, которое позволяет нам сделать рациональные и разумные выводы.",
	},
	{
		title: "Изготовление стелек",
		content: "Изготовление стелек - это процесс создания индивидуальных стелек или ортопедических стелек, которые предназначены для поддержки и улучшения анатомической структуры стопы. Стельки разрабатываются и изготавливаются с учетом индивидуальных особенностей стопы и нужд каждого человека.",
	},
	{
		title: "Индивидуум",
		content: "Индивидуум - это термин, используемый для обозначения отдельного человека, отдельного лица. Он описывает каждого уникального человека как отдельную и неповторимую личность. Индивидуум имеет свои собственные уникальные характеристики, включая физические, психологические и социальные аспекты.",
	},
	{
		title: "Информация",
		content: "Информация - это факты, данные или знания, которые передаются или получаются через различные источники и коммуникационные средства. Она представляет собой сведения, которые имеют значение и могут быть использованы для понимания, принятия решений или осуществления каких-либо действий.",
	},
	{
		title: "Компетентность",
		content: "Компетентность - это способность и квалификация человека эффективно выполнять определенные задачи или функции в конкретной области знаний, навыков или навыков. Она относится к способности применять знания и умения на практике для достижения желаемых результатов.",
	},
	{
		title: "Материя",
		content: "Материя - это основная составляющая физического мира, из которой состоят все вещества и объекты вокруг нас. Она имеет массу и занимает пространство. Материя состоит из атомов, которые взаимодействуют между собой и образуют молекулы.",
	},
	{
		title: "Обработка возражений",
		content: "Обработка возражений - это процесс реагирования на возражения или отрицательные мнения, которые могут возникнуть у людей во время общения, презентации продукта или услуги, продажи или любого другого взаимодействия с клиентами или потенциальными клиентами.",
	},
	{
		title: "Обучение",
		content: "Обучение - это процесс получения знаний, навыков, понимания или опыта, который происходит через изучение, практику и общение. Оно позволяет людям расширять свои знания, развивать умения и приобретать новые компетенции.",
	},
	{
		title: "Общение",
		content: "Общение - это процесс передачи информации, мыслей, идей, чувств и знаний между людьми или группами людей. Оно является основным способом взаимодействия между людьми и играет важную роль в обществе.",
	},
	{
		title: "Отношение",
		content: "Отношение - это эмоциональное, когнитивное и поведенческое отношение, которое человек имеет к определенному объекту, событию, идее, другому человеку или группе людей. Оно отражает чувства, убеждения, предпочтения, оценки и реакции, которые связаны с определенным объектом или ситуацией.",
	},
	{
		title: "Презентация услуг",
		content: "Презентация услуг - это процесс представления и демонстрации предлагаемых компанией или организацией услуг перед потенциальными клиентами, партнерами или заинтересованными сторонами. Цель презентации услуг состоит в информировании, привлечении внимания и убеждении аудитории в ценности и преимуществах предлагаемых услуг.",
	},
	{
		title: "Этика сотрудников Sanatera",
		content: "Этика сотрудников - это набор принципов, ценностей и норм поведения, которые регулируют действия и отношения сотрудников в рабочей среде. Она определяет, как сотрудники взаимодействуют друг с другом, с клиентами, партнерами и другими заинтересованными сторонами, а также как они принимают решения и выполняют свои обязанности.",
	},
];

const Glossary = () => {
	document.title = "Glossary | Archi-crm";

	const [accordionState, setAccordionState] = useState([]);

	const toggleAccordion = (index) => {
		setAccordionState((prevState) => {
			const newState = prevState.map((state, i) => {
				if (i === index) {
					return !state; // Открываем/закрываем аккордеон по индексу
				} else {
					return false; // Закрываем все остальные аккордеоны
				}
			});
			return newState;
		});
	};

	const createAccordionItem = (data, index) => {
		return (
			<div className="accordion-item" key={index}>
				<h2 className="accordion-header" id={`heading${index}`}>
					<button
						className={classnames("accordion-button", "fw-medium", {
							collapsed: !accordionState[index],
						})}
						type="button"
						onClick={() => toggleAccordion(index)}
						style={{ cursor: "pointer" }}
					>
						{data.title}
					</button>
				</h2>
				<Collapse
					id={`collapse${index}`}
					className="accordion-collapse"
					isOpen={accordionState[index]}
				>
					<div className="accordion-body">{data.content}</div>
				</Collapse>
			</div>
		);
	};

	useEffect(() => {
		const initialAccordionState = new Array(accordionData?.length).fill(false);
		setAccordionState(initialAccordionState);
	}, []);

	return (
		<div className="page-content">
			<div className="container-fluid">
				<Breadcrumbs title='Глоссарий ГК "Арчи"' breadcrumbItem='Глоссарий ГК "Арчи"' />
				<Card>
					<CardBody>
						<div className="accordion" id="accordionExample">
							{accordionData?.map((data, index) => createAccordionItem(data, index))}
						</div>
					</CardBody>
				</Card>
			</div>
		</div>
	);
};

export default Glossary;